var React = require('react');

function StepCircle0160px (props) {
    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M30 58c15.464 0 28-12.536 28-28S45.464 2 30 2 2 14.536 2 30s12.536 28 28 28zm0 2c16.569 0 30-13.431 30-30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30zm-.288-18h1.692V18.6H29.82l-4.428 2.628.432 1.368 3.816-2.232h.072V42z"}));
}

StepCircle0160px.displayName = "StepCircle0160px";

StepCircle0160px.defaultProps = {"viewBox":"0 0 60 60"};

module.exports = StepCircle0160px;

StepCircle0160px.default = StepCircle0160px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/60px/step-circle-01-60px.svg
// module id = 1206
// module chunks = 0